module.exports = __webpack_public_path__ + "static/media/less500-icon.408ba2ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/less500-icon.svg
// module id = 2874
// module chunks = 0